export const ALLOWED_AVAILABILITY_RADII = new Set(['10', '20', '25', '50', '100']);

export const COLLECTION_METHOD_DESCRIPTIONS = {
  at_home_phlebotomy: 'A phlebotomist visits your address to draw your sample.',
  walk_in_test: 'Visit a nearby lab to have your sample drawn.',
  testkit: 'A kit ships to you — collect your own sample and mail it back.',
  on_site_collection: 'Sample collected at the clinic or facility.',
};

export const COLLECTION_METHOD_BANNERS = {
  at_home_phlebotomy: "After checkout, we'll send next steps for booking your phlebotomy visit when your order is ready.",
  testkit: 'After checkout, your test kit ships to the address you provide.',
  walk_in_test: null,
  on_site_collection: null,
};

export const SMARTY_EMBEDDED_KEY = process.env.REACT_APP_SMARTY_EMBEDDED_KEY;

export const US_STATES = [
  ['AL', 'Alabama'], ['AK', 'Alaska'], ['AZ', 'Arizona'], ['AR', 'Arkansas'], ['CA', 'California'],
  ['CO', 'Colorado'], ['CT', 'Connecticut'], ['DE', 'Delaware'], ['FL', 'Florida'], ['GA', 'Georgia'],
  ['HI', 'Hawaii'], ['ID', 'Idaho'], ['IL', 'Illinois'], ['IN', 'Indiana'], ['IA', 'Iowa'],
  ['KS', 'Kansas'], ['KY', 'Kentucky'], ['LA', 'Louisiana'], ['ME', 'Maine'], ['MD', 'Maryland'],
  ['MA', 'Massachusetts'], ['MI', 'Michigan'], ['MN', 'Minnesota'], ['MS', 'Mississippi'], ['MO', 'Missouri'],
  ['MT', 'Montana'], ['NE', 'Nebraska'], ['NV', 'Nevada'], ['NH', 'New Hampshire'], ['NJ', 'New Jersey'],
  ['NM', 'New Mexico'], ['NY', 'New York'], ['NC', 'North Carolina'], ['ND', 'North Dakota'], ['OH', 'Ohio'],
  ['OK', 'Oklahoma'], ['OR', 'Oregon'], ['PA', 'Pennsylvania'], ['RI', 'Rhode Island'], ['SC', 'South Carolina'],
  ['SD', 'South Dakota'], ['TN', 'Tennessee'], ['TX', 'Texas'], ['UT', 'Utah'], ['VT', 'Vermont'],
  ['VA', 'Virginia'], ['WA', 'Washington'], ['WV', 'West Virginia'], ['WI', 'Wisconsin'], ['WY', 'Wyoming'],
];
